// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2EejH","icon":"styles_icon__3UB7V"};